import { Fragment } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Skeleton, Stack, Typography } from '@mui/material';

import { useNotifications } from '../hooks';

import { Card } from './Card';
import { HomeLayout } from './HomeLayout';

export const WhatsNew = () => {
  const { data: notifications, isFetching } = useNotifications();

  const validateURL = (urlString: string): string => {
    try {
      new URL(urlString);
      return urlString;
    } catch (_) {
      return '/';
    }
  };

  return (
    <HomeLayout title="What's new">
      <Card
        bottomLink={{
          link: 'https://support.changegps.com.au/en/knowledge/recent-updates',
          text: 'View all recent updates',
        }}
      >
        {isFetching ? (
          <LoadingSkeleton />
        ) : (
          <Fragment>
            {notifications?.map((item) => {
              const link = validateURL(item.link);

              return (
                <Box key={item.nid} mb={1}>
                  <Box
                    component="a"
                    sx={{
                      backgroundColor: '#F9F9FA',
                      p: '8px 16px',
                      borderRadius: 2,
                      cursor: 'pointer',
                      display: 'block',
                      textDecoration: 'none',
                      color: 'inherit',
                    }}
                    href={link}
                  >
                    <Stack direction="row" alignItems="center">
                      <Box sx={{ flex: 1 }}>
                        <Stack direction="row" alignItems="center" mb={0.25}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: 15,
                              lineHeight: 1.6,
                            }}
                          >
                            {item.app}
                          </Typography>

                          <Box sx={{ width: 4 }} />

                          <Box
                            sx={{
                              backgroundColor:
                                item.tag === 'Updated' ? '#0075C9' : '#2D864B',
                              px: 1,
                              borderRadius: 30,
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFF',
                                fontSize: 11,
                                lineHeight: '18px',
                              }}
                            >
                              {item.tag}
                            </Typography>
                          </Box>
                        </Stack>

                        <Typography sx={{ fontWeight: 400, fontSize: 13 }}>
                          {item.message}
                        </Typography>
                      </Box>

                      <ChevronRightIcon />
                    </Stack>
                  </Box>
                </Box>
              );
            })}
          </Fragment>
        )}
      </Card>
    </HomeLayout>
  );
};

const LoadingSkeleton = () => {
  return (
    <Stack spacing={1}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width={'100%'} height={64} />
      ))}
    </Stack>
  );
};
